import { type HttpClientConfig } from 'core/infra/http/HttpClient'
import { openFile } from 'core/utils/browser'

import { createAllInOneHttpClient } from '../../core/infra/createAllInOneHttpClient'
import {
  type AttachmentRequestBody,
  PendingTendersRepository,
} from '../infra/PendingTendersRepository'

export async function downloadAttachment(
  body: AttachmentRequestBody,
  config?: Partial<HttpClientConfig>
) {
  const httpClient = createAllInOneHttpClient()
  const repository = new PendingTendersRepository({ httpClient })

  const attachmentURL = await repository.getAttachmentURL(body, config)

  openFile(attachmentURL)

  return attachmentURL
}
